import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconPlace from '@/icons/Place.svg';

import { useFilters } from '../FiltersState';

export const FiltersDestination = () => {
  const { t } = useLingui();

  const {
    destinations: { destinations, setDestinations },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="destination"
      selectedEntities={destinations}
      setSelectedEntities={setDestinations}
      traits={['store', 'workshop']}
      label={t({ id: 'shipments.filters.destination.label', message: 'Destination' })}
      searchPlaceholder={t({
        id: 'shipments.filters.destination.search.label',
        message: 'Search destinations',
      })}
      icon={<IconPlace end />}
    />
  );
};
